var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yhc-component 改成文件名字一样"},[_c('h1',[_vm._v("1")])])
}]

export { render, staticRenderFns }